<template>
    <div id="app" :class="[isImmerse && 'has-top']" :style="{'opacity': !pageLoading ? 1 : 0}">
        <!-- 顶部分享按钮 -->
        <div class="top" v-if="isImmerse" :style="{'top': statusBarHeight+'px'}">
            <button class="back-btn" @click="back"></button>
            <button class="share-btn" @click="shareLink"></button>
        </div>
        <div class="music" :style="{'top': statusBarHeight+'px'}">
            <button class="music-btn" :class="!musicFlag && 'off'" @touchstart="switchMusic"></button>
            <audio id="music" autoplay :data-play="musicFlag" loop="loop" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1du49c1ptuc41eq11ji68rcjge9.mp3"></audio>
        </div>
        <base-component :baseData="baseData" v-if="baseData"></base-component>
        <router-view v-if="baseData" :style="{'padding-top': statusBarHeight+'px'}"/>        
    </div>
</template>

<script>
import WX from 'wechat-js-sdk'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import BaseComponent from '@/components/Base'

import {mapState, mapActions} from 'vuex'

export default {
    data() {
        return {
            musicFlag: true,
            baseData: null,
            statusBarHeight: 0,
            thisPage: ''
        }
    },
    computed: {
        ...mapState(['aid', 'isApp', 'versionSize', 'userinfo', 'pageLoading', 'shareData', 'isImmerse', 'maskData'])
    },
    components: {
        BaseComponent
    },
    watch: {
        '$route'(to, from) {
            this.thisPage = to.name
            if(!this.userinfo.user_id && this.thisPage != 'home' && this.thisPage != 'rule' && this.thisPage != 'dynamic') {
                this.$router.replace('/')
            }
            this.setPageLoadingAsync(true)
            document.querySelector('.loading-wrap').style.display = 'block'
            this.setHbShowFlagAsync(null)
            if(this.maskData && this.maskData.type != 1 && this.maskData.type != 2 && this.maskData.type != 3) {
                this.setMaskDataAsync(null)
            }           
        }
    },
    created() {
        this.getActivityData()
    },
    mounted() {
        this.appFlagAsync(COVERAPP.Attribute.isApp())
        let _this = this
        let isFromSecondFloor = false
        if(this.isApp) {
            let version = COVERAPP.Attribute.appVersion();
            let versionNum = version.split('.');
            let versionSize = parseInt(versionNum.join(''));
            this.setVersionSizeAsync(versionSize);
            if(this.versionSize >= 570 ) {
                COVERAPP.Method.getWebInfo({
                    callback(ret) {
                        let data = typeof ret == 'object'.toLowerCase() ? JSON.stringify(ret) : ret;
                        if(JSON.parse(data).showType == 1) {
                            _this.setIsImmerseAsync(true)
                            let statusBarHeight = JSON.parse(data).statusBarHeight
                            if(COVERAPP.Attribute.isAndroid()) {
                                let devicePixelRatio = (typeof window.devicePixelRatio).toLowerCase() == 'number' ? window.devicePixelRatio : 0
                                _this.statusBarHeight = devicePixelRatio ? statusBarHeight / devicePixelRatio : statusBarHeight
                            } else {
                                _this.statusBarHeight = statusBarHeight
                            }
                        }
                        if(JSON.parse(data).isFromSecondFloor == 1) {
                            isFromSecondFloor = true
                            COVERAPP.Method.webContentLoadFinish()
                        }					
                    }
                })
            }
        }
        _this.setPageLoadingAsync(false)
        // clearTimeout(timeoutIds)
        document.querySelector('.loading-wrap').style.display = 'none'
        this.musicPlay()
    },
    methods: {
        ...mapActions([
            'setHbShowFlagAsync',
            'setPageLoadingAsync',
            'setIsImmerseAsync',
            'appFlagAsync',
            'checkCanGetHb',
            'getActivityDataAsync',
            'setVersionSizeAsync',
            'setMaskDataAsync',
            'getUserinfoAsync',
            'setshareDataAsync',
        ]),
        getActivityData() {
            COVER.$request('/activity/config', {
                aid: this.aid
            }, 'get').then((res) => {
                if(res.errno == 0 && res.data) {
                    this.baseData = res.data
                    this.getActivityDataAsync(res.data)
                    this.setshareDataAsync(res.data.share);
                    // COVER.share(res.data.share);
                }
            })
        },
        musicPlay() {
            let _this = this
            let music = document.getElementById('music')
            if(this.musicFlag) {
                music.play()
            }
            // 微信自动播放            
            document.addEventListener("WeixinJSBridgeReady", ()=> {
                if(this.musicFlag) {
                    music.play()
                }
            }, false)
            // 兼容其他不自动播放的情况
            document.addEventListener("touchstart", () => {
                if(this.musicFlag && this.thisPage == 'home') {
                    music.play()
                }
            }, false)
            // 安卓app不自动播放
            if(this.isApp) {
                let isLoad_Bridging = setInterval(()=> {
                    try {
                        COVERAPP.Method.GetUser({
                            callback(ret) {
                                clearInterval(isLoad_Bridging);
                                if(_this.isApp && COVER.isEmpty(_this.userinfo.user_id)) {
                                    _this.getUserinfoAsync()
                                }
                                if(_this.musicFlag) {
                                    music.play()
                                }
                            }
                        });
                    } catch (e) {}
                }, 300)               
            }
        },
        switchMusic(e) {
            let music = document.getElementById('music')
            this.musicFlag && e.stopPropagation();
            this.musicFlag = !this.musicFlag
            if(this.musicFlag) {
                music.play()
            } else {
                music.pause()
            }
        },
        back() {
            if(this.thisPage != 'home') {
                this.$router.back(-1)
            } else {
                COVERAPP.Method.Back()
            }           
        },
        shareLink() {
            let _this = this
            let ShareData = JSON.parse(JSON.stringify(this.shareData))
            ShareData.callback = function(ret) {
                var data = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret; 
                var origin = data.origin || '';
				if(origin != 'None' && !COVER.isEmpty(origin)){
					COVER.track(_this.aid, 'share', '分享链接到'+origin);  
				} else {
					COVER.track(_this.aid, 'share', '分享'); 
				}
                if((data.status == 'success' || data.status == '1') && _this.userinfo.user_id && _this.thisPage != 'game'){
                    _this.checkCanGetHb(2).then(()=> {
                        COVER.track(_this.aid, 'load', '分享进入红包雨')	
                        _this.$router.push('/game?type=2')
                    })
                }           
            }
            ShareData.type = 'link';
            ShareData.origin = 'None';
            COVERAPP.Method.Share(ShareData)
        }
    }
}
</script>

<style lang="less">
    .has-top .wrapper{
        box-sizing: border-box;
    }
    .top {
        position: fixed;
        width: 100%;
        left: 0;
        top:0;
        height: 1.046699rem;
        z-index: 20;
    }
    .back-btn {
        width: .692432rem;
        height: .724638rem;
        position: absolute;
        top: .305958rem;
        left: .587762rem;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261id2iomlg5of41lp62k.png) no-repeat center top;
        background-size: 100% auto;
        z-index: 10; 
    }
    .share-btn {
        width: .68438rem;
        height: .716586rem;
        position: absolute;
        top: .305958rem;
        right: .386473rem;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm2717lf1elp1ff19un1b6k46.png) no-repeat center top;
        background-size: 100% auto;
        z-index: 10;
    }
    .music {
        position: fixed;
        top: 0;
        right: 1.545894rem;
        width: .716586rem;
        height: 1.1rem;
        z-index: 20;
        .music-btn {
            position: absolute;
            top: .305958rem;
            width: 100%;
            height: .764895rem;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27d0vvl96571ej71l4949.png) no-repeat center top;
            background-size: 100% 200%;
            &.off {
                background-position: center bottom;
            }
        }
    }
</style>
